export default __webpack_public_path__ + "static/media/edit.249fb4c7.svg";